module.exports = __webpack_public_path__ + "static/img/14020B_4_C_20200316_LC.8b753ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14020B_4_C_20200316_LC.png
// module id = GNM3
// module chunks = 0